// extracted by css-extract-rspack-plugin
export default {"MediaAsset":"MediaAsset-module__MediaAsset__BWWd4C3","Image":"MediaAsset-module__Image__k_q9g8W"};